import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
	Typography,
} from '@material-ui/core';

import useStyles from './HomePage.styled';
import WeatherIcon from '../../components/WeatherIcon';
import LastUpdated from '../../components/LastUpdated';
import { useWeather } from '../../hooks/Weather';
import { capitaliseString, getTimeFromDate } from '../../utils';

const HomePage = () => {
	const { id } = useParams();
	const classes = useStyles();
	const { locations } = useWeather();
	const [currentLocation, setCurrentLocation] = useState(null);

	useEffect(() => {
		if (id && locations) {
			setCurrentLocation(locations.find((location) => `${id}` === `${location.id}`));
		}
	}, [id, locations]); // eslint-disable-line
	return (
		<>
			{currentLocation ? (
				<>
					<LastUpdated location={currentLocation} />

					<div className={classes.weatherIconContainer}>
						<WeatherIcon
							icon={currentLocation.icon}
						/>
					</div>

					<div className={classes.aside}>
						<Typography>{`Temperature: ${currentLocation.temperature}\u00B0`}</Typography>
						<Typography>{`Min Temperature: ${currentLocation.temperatureMin}\u00B0`}</Typography>
						<Typography>{`Max Temperature: ${currentLocation.temperatureMax}\u00B0`}</Typography>
						<Typography>{`Sunrise: ${getTimeFromDate(currentLocation.sunrise * 1000)}`}</Typography>
						<Typography>{`Sunset: ${getTimeFromDate(currentLocation.sunset * 1000)}`}</Typography>
						<Typography>{capitaliseString(currentLocation.description)}</Typography>
						<Typography><strong>{`${currentLocation.city}, ${currentLocation.country}`}</strong></Typography>
					</div>
				</>
			) : (
				<Typography className={classes.text}>
					No Location selected. Please select a location
				</Typography>
			)}
		</>
	);
};

export default HomePage;
